// Dashboard principal do Financeiro Comunidade (M11 refactor).
// Após ativado, essa é a landing (/comunidade/financeiro) com só:
// - Saldo do time (grande)
// - Créditos disponíveis + botão comprar
// - Últimas cobranças (card com preview + link "Ver todas")
// Extrato, configurações e histórico de créditos foram pra páginas próprias
// via submenu do menu Financeiro.

import React, { useCallback, useEffect, useState } from 'react';
import { Card, Typography, Row, Col, Statistic, Space, Tag } from 'antd';
import { DollarOutlined, ClockCircleOutlined, WalletOutlined } from '@ant-design/icons';
import api from '../../../services/api';
import OpeningBalanceModal from './OpeningBalanceModal';
import CreditsPurchaseCard from './CreditsPurchaseCard';
import RecentBatchesCard from './charges/RecentBatchesCard';
import UpcomingRecurrencesCard from './charges/UpcomingRecurrencesCard';
import DashboardCharts from './DashboardCharts';

const { Title, Text } = Typography;
const PRIMARY = '#128C7E';
const fmtBRL = (v) => `R$ ${Number(v || 0).toFixed(2).replace('.', ',')}`;

export default function FinanceDashboard({ teamName, communityTeamId }) {
  const [openedAt, setOpenedAt] = useState(null);
  const [balance, setBalance] = useState(0);
  const [pendingRelease, setPendingRelease] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [showOpening, setShowOpening] = useState(false);

  const loadAccount = useCallback(async () => {
    if (!communityTeamId) return;
    try {
      const r = await api.get('/community/finance/accounts/entries', {
        params: { team_id: communityTeamId, page: 1, limit: 1 },
      });
      setBalance(r.data.balance_brl);
      setPendingRelease(r.data.pending_release_brl || 0);
      setPendingCount(r.data.pending_release_count || 0);
      setOpenedAt(r.data.opened_at);
      if (r.data.opened_at == null) setShowOpening(true);
    } catch (e) { /* silent */ }
  }, [communityTeamId]);

  useEffect(() => { loadAccount(); }, [loadAccount]);

  return (
    <div style={{ padding: '16px 12px', maxWidth: 1200, margin: '0 auto' }}>
      <Title level={4} style={{ marginTop: 0 }}>Financeiro · {teamName}</Title>

      {/* Cards principais: 3 KPIs */}
      <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
        <Col xs={24} sm={12} md={8}>
          <Card size="small" styles={{ body: { padding: 16 } }}
            style={{ borderColor: PRIMARY, background: '#f0faf7', height: '100%' }}>
            <Statistic
              title={<Space><WalletOutlined /><Text strong>Saldo disponível</Text></Space>}
              value={balance}
              precision={2}
              prefix="R$"
              valueStyle={{ color: PRIMARY, fontSize: 28 }}
            />
            <Text type="secondary" style={{ fontSize: 12 }}>
              {openedAt
                ? `Conta aberta em ${new Date(openedAt).toLocaleDateString('pt-BR')}`
                : 'Aguardando saldo inicial'}
            </Text>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card size="small" styles={{ body: { padding: 16 } }}
            style={{ borderColor: '#faad14', background: '#fffbe6', height: '100%' }}>
            <Statistic
              title={<Space><ClockCircleOutlined /><Text strong>A receber</Text></Space>}
              value={pendingRelease}
              precision={2}
              prefix="R$"
              valueStyle={{ color: '#faad14', fontSize: 28 }}
              suffix={pendingCount > 0 ? <Text type="secondary" style={{ fontSize: 12 }}> · {pendingCount} cobr.</Text> : null}
            />
            <Text type="secondary" style={{ fontSize: 12 }}>Cartão em processamento MP</Text>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <CreditsPurchaseCard communityTeamId={communityTeamId} />
        </Col>
      </Row>

      {/* Gráficos (M11 P3) */}
      <DashboardCharts communityTeamId={communityTeamId} />

      {/* Próximas recorrências (M12) */}
      <UpcomingRecurrencesCard communityTeamId={communityTeamId} />

      {/* Últimas cobranças */}
      <RecentBatchesCard communityTeamId={communityTeamId} />

      <OpeningBalanceModal
        open={showOpening}
        communityTeamId={communityTeamId}
        onClose={() => setShowOpening(false)}
        onSaved={() => { setShowOpening(false); loadAccount(); }} />
    </div>
  );
}
